<template>
    <div class="product-share">
        {{ 'divide' | translation }}
        <v-btn
            color="primary"
            fab
            small
            :href="'mailto:?subject=\'Ich möchte Dir diesen Artikel bei Mollback empfehlen&body=Ich möchte Dir diesen Artikel bei Mollback empfehlen\':%0A' + productName + '%0AWeitere Informationen: ' + productLink"
        >
            <v-icon>email</v-icon>
        </v-btn>
        <!--<div :class="{'fb-share-button': showFBShare}" data-layout="button" data-size="small" data-mobile-iframe="true" ref="facebookShareButton"></div>-->
        <v-btn
            color="primary"
            fab
            small
            :href="'https://www.facebook.com/sharer/sharer.php?u=' + productLink + '&t=' + productName"
            target="_blank"
        >
            <span class="fa fa-facebook" style="font-size: 20px;"></span>
        </v-btn>
        <v-btn
            color="primary"
            fab
            small
            class="hidden-md-and-up"
            :href="'whatsapp://send?text=\'Ich möchte Dir diesen Artikel bei Mollback empfehlen\':%0A' + productName + '%0A ' + productLink"
        >
            <span class="fa fa-whatsapp" style="font-size: 20px;"></span>
        </v-btn>
    </div>
</template>

<script>
    import {createNamespacedHelpers} from 'vuex';

    const parentModuleName = 'Product';
    const { mapState, mapGetters } = createNamespacedHelpers(parentModuleName);

    export default {
        name: "SharingButtons",
        data() {
            return {
                showFBShare: false,
            };
        },
        created: function () {
            this.$nextTick(() => {
                this.showFBShare = true;
                this.$nextTick(() => {
                    if (this.$refs.facebookShareButton && !this.$refs.facebookShareButton.getAttribute('fb-xfbml-state')) {
                        if (typeof FB !== 'undefined') {
                            FB.XFBML.parse(this.$el);
                        }
                    }
                });
            });
        },
        beforeDestroy: function () {
            this.showFBShare = false;
        },
        computed: mapState({
            productName: state => {
                return this.getProductAttributeByLanguage(state.product, 'product.name');
            },
            productLink: state => {
                let result = '';
                let product = state.product;
                if (product && product._links && product._links.self && product._links.self.href) {
                    result = product._links.self.href;
                }
                return result;
            },
            ...mapGetters([
                'getProductAttributeByLanguage'
            ])
        })
    };
</script>